import type { AnalysisDetails, AnalysisPurchase } from "./Analysis";

const WENT_WELL_LIMIT = 3;

// «Получилось»: ключевые предметы, купленные вовремя, — самые популярные у сильных игроков
// первыми, не больше трёх. Подробностей нет — пусто.
export const selectWentWell = (details: AnalysisDetails | null): AnalysisPurchase[] =>
  (details?.purchases ?? [])
    .filter((purchase) => purchase.verdict === "on_time" && purchase.baseline_at_s !== null)
    .sort((a, b) => (b.pick_rate ?? 0) - (a.pick_rate ?? 0) || a.bought_at_s - b.bought_at_s)
    .slice(0, WENT_WELL_LIMIT);
